import React from 'react';
import CalendarCard from '../../components/CalendarCard';
import { COLORS, LAYOUT } from '../../constants';

// Empty Calendar Icon
const EmptyCalendarIcon = () => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke={COLORS.text.muted} strokeWidth="1.5">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <circle cx="12" cy="15" r="2" fill={COLORS.text.muted} />
  </svg>
);

// Spinner Icon
const SpinnerIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke={COLORS.primary} strokeWidth="3" strokeLinecap="round" strokeDasharray="32 32" opacity="0.25" />
    <circle cx="12" cy="12" r="10" stroke={COLORS.primary} strokeWidth="3" strokeLinecap="round" strokeDasharray="32 32" strokeDashoffset="8">
      <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite" />
    </circle>
  </svg>
);

const eventsListStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: LAYOUT.spacing.md
  },
  
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${LAYOUT.spacing.xxxl}px 0`,
    gap: LAYOUT.spacing.md
  },
  
  loadingText: {
    color: COLORS.text.secondary,
    fontSize: 16,
    fontWeight: 500
  },
  
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${LAYOUT.spacing.xxxl}px 0`,
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
    gap: LAYOUT.spacing.lg
  },
  
  emptyText: {
    color: COLORS.text.muted,
    fontSize: 18,
    fontWeight: 500,
    textAlign: 'center'
  },
  
  emptySubtext: {
    color: COLORS.text.secondary,
    fontSize: 14,
    textAlign: 'center',
    maxWidth: 400
  }
};

const EventsList = ({ events, loading, dateStr }) => {
  if (loading) {
    return (
      <div style={eventsListStyles.loadingContainer}>
        <SpinnerIcon />
        <div style={eventsListStyles.loadingText}>Loading events...</div>
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div style={eventsListStyles.emptyContainer}>
        <EmptyCalendarIcon />
        <div style={eventsListStyles.emptyText}>No events scheduled</div>
        <div style={eventsListStyles.emptySubtext}>
          You don't have any meetings scheduled for this date. Accepted meeting invitations will appear here.
        </div>
      </div>
    );
  }

  return (
    <div style={eventsListStyles.container}>
      {events.map(event => (
        <CalendarCard key={event.id} event={event} />
      ))}
    </div>
  );
};

export default EventsList;